import { takeEvery, put, call } from 'redux-saga/effects';
import * as Api from 'lib/Api';
import * as ActionAuth from 'reducer/AuthReducer';
import * as ActionLoad from 'reducer/LoadReducer';
import { isLoggedIn } from 'lib/AuthUtil';
import Config from '../lib/Config';

function* LogInLinkSaga(action) {
  const loggedIn = yield call(isLoggedIn);

  if (!loggedIn) {
    const { history } = action.payload;
    yield put(ActionAuth.logOut(history));
    return false;
  }

  yield buildSession(action);
}

function* LogOutSaga(action) {
  const { history } = action.payload;

  Api.removeStorage(Config.BEARERTOKEN);

  if (history && history.location && history.location.pathname !== '/') {
    history.push('/');
  }
}

function* buildSession(action) {
  if (Api.getStorage(Config.BEARERTOKEN)) {
    yield put(ActionAuth.logIn());
    return false;
  }

  yield put(ActionLoad.showLoad());

  try {
    const { data } = yield call(Api.postSessionToken);
    Api.addStorage(Config.BEARERTOKEN, data.accessToken);

    yield put(ActionAuth.logIn());
  } catch (error) {
    if (error.response && error.response.status === 404) {
      yield put(ActionAuth.logInLinkFailure());
      yield put(ActionLoad.hideLoad());
      return;
    }

    const { history } = action.payload;
    yield put(ActionAuth.logOut(history));
  }

  yield put(ActionLoad.hideLoad());
}

export function* watchLogInLink() {
  yield takeEvery(ActionAuth.LOGIN_LINK, LogInLinkSaga);
}

export function* watchLogOut() {
  yield takeEvery(ActionAuth.LOGOUT, LogOutSaga);
}
